import reportError from "@/utils/reportError"

export default function (routeKey, mainKey, loadComponent) {
  const myLoadComponent = function (type) {
    let result = null
    if (loadComponent != null) result = loadComponent(type)

    if (result != null) return result

    switch (type) {
      case "list":
        return import(`../views/pages/${mainKey}/list.vue`)
      case "create":
        return import(`../views/pages/${mainKey}/create.vue`)
      case "detail":
        return import(`../views/pages/${mainKey}/details.vue`)
      case "update":
        return import(`../views/pages/${mainKey}/create.vue`)
      default:
        reportError(new Error("Unknown CRUD component type"), {
          context: "router.crud",
          type,
          routeKey,
          mainKey
        })
        console.error("crud load component failed for type:", type)
        break
    }
  }
  return [
    {
      path: "/" + mainKey,
      name: routeKey,
      component: () => myLoadComponent("list"),
      meta: { titleKey: mainKey + ".route" }
    },
    {
      path: "/" + mainKey + "/create",
      name: routeKey + ".Create",
      component: () => myLoadComponent("create"),
      meta: { title: `Create ${routeKey.toLowerCase()}` }
    },
    {
      path: "/" + mainKey + "/details/:id",
      name: routeKey + ".View",
      component: () => myLoadComponent("detail"),
      meta: { title: `${routeKey} details` }
    },
    {
      path: "/" + mainKey + "/edit/:id",
      name: routeKey + ".Edit",
      component: () => myLoadComponent("update"),
      meta: { title: `Edit ${routeKey.toLowerCase()}` }
    }
  ]
}
